import React, {Component} from 'react';
import { FormattedMessage, injectIntl } from "react-intl";
import SAButton from "../../common/button/SAButton";
import PlanningCalendar from "./PlanningCalendar";
import {connect} from "react-redux";
import { EXCHANGE_TIRES, EXCHANGE_WHEELS, getCamelCaseType } from "../WheelsExchangeUtils";
import PlanningSlots from "./PlanningSlots";
import moment from 'moment';
import Constants from "../../../services/Constants";
import LoadingIndicator from "../../common/loading/LoadingIndicator";
import {withRouter} from "react-router-dom";
import queryString from 'query-string';

class ExchangePlanning extends Component {

  constructor(props) {
    super(props);
    this.state = {
      planning: {},
      selectedDay: (props.day) ? props.day : moment().format(Constants.DATE_FORMAT_API) // by default select today
    }
  }

  componentDidMount() {
    const {type, dispatchFetchWheelsExchangePlanning, dispatchFetchWheelsExchangeSlots} = this.props;
    const {selectedDay} = this.state;
    dispatchFetchWheelsExchangePlanning({type, day: selectedDay});
    dispatchFetchWheelsExchangeSlots({type, day: selectedDay});
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.fetchWheelsExchangePlanning && nextProps.fetchWheelsExchangePlanning.planning) {
      this.setState({planning: nextProps.fetchWheelsExchangePlanning.planning});
    }
  }

  onSelectedDateChange = day => {
    const {type, dispatchFetchWheelsExchangePlanning, dispatchFetchWheelsExchangeSlots} = this.props;
    const {selectedDay} = this.state;
    if (moment(day).year() !== moment(selectedDay).year()) {
      dispatchFetchWheelsExchangePlanning({type, day});
    }
    dispatchFetchWheelsExchangeSlots({day, type});
    this.setState({selectedDay: day})
    this.updateUrl(day)

  };

  updateUrl = (day)=>{
    const {type, history, location} = this.props
    const parsed = queryString.parse(location.search);
    const queryParam = type === EXCHANGE_TIRES ? 'tday' : 'wday';
    parsed[queryParam] = day;
    location.search = queryString.stringify(parsed);
    history.replace(`/tire-management?${location.search}`)
  }

  onPrint = (type) => {
    const head = document.getElementsByTagName('head')[0];
    const newStyle = document.createElement('style');
    newStyle.setAttribute('type', 'text/css');
    newStyle.setAttribute('media', 'print');
    const printId = type === EXCHANGE_TIRES ? EXCHANGE_WHEELS : EXCHANGE_TIRES;
    newStyle.appendChild(document.createTextNode(`#print-panning-${printId} { display: none!important;}`));
    head.appendChild(newStyle);
    window.print();
    newStyle.remove();
  };

  render() {
    const {intl: {formatMessage}, type, fetchWheelsExchangePlanning: {loading}, index} = this.props;
    const {planning, selectedDay} = this.state;
    return (
      <section className="box" id={`print-panning-${type}`}>
        <header className="box-heading">
          <h2 className="box-heading__title">
            <FormattedMessage id={`section.exchange-management.${type}.title`}/>
          </h2>
          <div className="box-heading__right">
            <SAButton
              type='primary'
              onClick={() => this.onPrint(type)}
              className="btn btn-sm btn-primary right print-btn"
            >
              {formatMessage({id: 'action.print'})}
            </SAButton>
          </div>
        </header>

        <div className="box__body">
          <div className="row">
            <div className="col-md-6 col-xxl-6">
              {loading ?
                <LoadingIndicator/>
                :
                <PlanningCalendar planning={planning} selectedDay={selectedDay} onSelect={this.onSelectedDateChange} />
              }
            </div>
            <div className="col-md-6 col-xxl-6">
              <PlanningSlots type={type} day={selectedDay} index={index}/>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

const mapStateToProps = (state, ownProps)=> {
  const camelCaseType = getCamelCaseType(ownProps.type);
  const fetchWheelsExchangePlanning = state[`fetch${camelCaseType}ExchangePlanning`];
  return {
    fetchWheelsExchangePlanning
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  dispatchFetchWheelsExchangePlanning: request => dispatch({type: `FETCH_${ownProps.type}_EXCHANGE_PLANNING.REQUEST`, request}),
  dispatchFetchWheelsExchangeSlots: request => dispatch({type: `FETCH_${ownProps.type}_EXCHANGE_SLOTS.REQUEST`, request})
});

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(ExchangePlanning)));



// WEBPACK FOOTER //
// ./src/components/wheelsexchange/management/ExchangePlanning.js